/** Base row styling only — no selected/disabled/highlight states; each consumer layers its own. */
export const OPTION_ROW_BASE_CLASS_NAME =
  "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none";
